import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';

import { getDate } from '../AvailabilityCalendar/date-utils';

import Divider from '../../components/Divider';
import Form from '../../components/Form';
import Grid from '../../components/Grid';
import Header from '../../components/Header';
import messages from './messages';
import './styles.css';

export const MAX_MESSAGE_LENGTH = 1000;

export class EventVisitCancelComponent extends React.PureComponent {
  static propTypes = {
    title: PropTypes.node.isRequired,
    cancelButtonLabel: PropTypes.node.isRequired,
    highSchool: PropTypes.object.isRequired,
    eventDetails: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  state = {
    messageText: '',
  };

  cancelVisit = (e) => {
    e.preventDefault();
    this.props.onCancel(this.state.messageText);
  }

  handleMessageTextChange = (_, { value }) => {
    let message = value;
    if (message.length > MAX_MESSAGE_LENGTH) {
      message = message.slice(0, MAX_MESSAGE_LENGTH);
    }
    this.setState({ messageText: message });
  };

  render() {
    const { eventDetails, highSchool, goBack, title, cancelButtonLabel, loading } = this.props;
    const { messageText } = this.state;
    const { contact, timezone, startISOTime, endISOTime, date } = eventDetails;
    const highSchoolName = get(highSchool, 'name');
    const start = getDate(date, startISOTime);
    const end = getDate(date, endISOTime);
    return (
      <Form styleName="cancel-visit-details">
        <div styleName="cancel-visit-content">
          <Header as="h1" styleName="header-text">
            <FormattedMessage {...messages.cancellationHeader} />
          </Header>
          <Header as="h2" styleName="section-title">
            {title}
          </Header>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div styleName="detail-label">
                  <FormattedMessage {...messages.contact} />
                </div>
                <div styleName="sidebar-text-bold">
                  {get(contact, 'name')}, {get(contact, 'field_job_position')}
                </div>
              </Grid.Column>
              <Grid.Column>
                <div styleName="detail-label">
                  <FormattedMessage {...messages.school} />
                </div>
                <div styleName="sidebar-text-bold">
                  {highSchoolName}
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <div styleName="detail-label">
                  <FormattedMessage {...messages.date} />
                </div>
                <div>
                  <FormattedDate
                    value={start}
                    weekday="long"
                    month="long"
                    day="numeric"
                    year="numeric"
                  />
                </div>
              </Grid.Column>
              <Grid.Column>
                <div styleName="detail-label">
                  <FormattedMessage {...messages.time} />
                </div>
                <div>
                  <FormattedTime value={start} />-<FormattedTime value={end} /> ({timezone})
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Divider section />
          <div styleName="required">
            <label htmlFor="cancel-message">
              <FormattedMessage {...messages.cancellationPrompt} />
            </label>
          </div>
          <Form.TextArea
            disabled={loading}
            autoHeight
            id="cancel-message"
            styleName="cancel-message"
            value={messageText}
            onChange={this.handleMessageTextChange}
            maxLength={MAX_MESSAGE_LENGTH}
          />
        </div>
        <div styleName="footer">
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column textAlign="left">
                <Form.Button onClick={goBack}>
                  <FormattedMessage {...messages.cancellationGoBack} />
                </Form.Button>
              </Grid.Column>
              <Grid.Column textAlign="right">
                <Form.Button
                  data-cy="cancel-submit"
                  loading={loading}
                  onClick={this.cancelVisit}
                  color="red"
                  disabled={messageText.length === 0}
                >
                  {cancelButtonLabel}
                </Form.Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Form>
    );
  }
}

export default EventVisitCancelComponent;
